import React from "react";
import {EditProps} from "react-admin";

import {CustomEdit} from "../../components/CustomEdit";
import {ImportFunctionForm} from "./ImportFunctionCreate";

export const ImportFunctionEdit = (props: EditProps) => (
  <CustomEdit
    {...props}
    transform={(data: any) => {
      const {sample_file, header_row_display, ...importFunction} = data;
      return {
        ...importFunction,
        header_row: Math.max(0, Number(header_row_display || 1) - 1),
      };
    }}
  >
    <ImportFunctionForm />
  </CustomEdit>
);
